import { render, staticRenderFns } from "./SettingsImportSection.vue?vue&type=template&id=7fdbc01b&"
import script from "./SettingsImportSection.vue?vue&type=script&lang=js&"
export * from "./SettingsImportSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.STrKMrcDoQYq/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fdbc01b')) {
      api.createRecord('7fdbc01b', component.options)
    } else {
      api.reload('7fdbc01b', component.options)
    }
    module.hot.accept("./SettingsImportSection.vue?vue&type=template&id=7fdbc01b&", function () {
      api.rerender('7fdbc01b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/Settings/SettingsImportSection.vue"
export default component.exports